import { render, staticRenderFns } from "./step-contacts-seller-call.vue?vue&type=template&id=a953096a"
import script from "./step-contacts-seller-call.vue?vue&type=script&lang=ts"
export * from "./step-contacts-seller-call.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports